<template>
    <div>
        <!--<img class="top" alt="EmAtlas logo" src="../assets/img/ematlas.png">-->
        <el-row style="padding: 0px;margin: 0px; ">
            <!--<el-col :md="1"><nav class="navbar navbar-default navbar-static-top" style="border: 1px solid #e7e7e7; margin-bottom: 0px"></nav></el-col>-->

        <nav class="navbar navbar-default navbar-static-top" style="border-bottom: 1px solid #e7e7e7; border-top:0px; margin-bottom: 0px;font-size: 16px">
            <el-col :xs="{span: 24, offset: 0}" :sm="{span: 24, offset: 0}" :md="{span: 24, offset: 0}">
                <div class="navbar-header">
                    <button type="button" class="navbar-toggle" data-toggle="collapse" data-target=".navbar-collapse">
                        <span class="sr-only"></span>
                        <span class="icon-bar"></span>
                        <span class="icon-bar"></span>
                        <span class="icon-bar"></span>
                    </button>
                    <a class="navbar-brand" href="" >
                        <span class="logo-name" style="margin-top: 120px">RaacFold</span>
                    </a>

                </div>
                <div class="collapse navbar-collapse">
                    <ul class="nav navbar-nav text-center">
                        <li id="Home">
                            <router-link to="/" tag="a">Home</router-link>
                        </li>
                        <li id="Search">
                            <router-link to="/protein" tag="a">ProteinAnalysis</router-link>
                        </li>
                        <li id="Analysis">
                            <router-link to="/align" tag="a">AlignAnalysis</router-link>
                        </li>
                        <li id="Tools">
                            <router-link to="/multi" tag="a">MultiAnalysis</router-link>
                        </li>
                        <li id="Statistics">
                            <router-link to="/statistics" tag="a">Statistics</router-link>
                        </li>
                        <li id="Help">
                            <router-link to="/help" tag="a">Help</router-link>
                        </li>
                        <li id="Contact">
                            <router-link to="/contact" tag="a">Contact</router-link>
                        </li>
                    </ul>
                </div>
            </el-col>
        </nav>

        </el-row>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                height: '51px',
                labelPosition:1,
                info_class:'baimoc-info',
                box_shadow:'rgba(0, 0, 0, 0.08) 0px 1px 4px 0px'
            }
        },
        name: "Detail",
        methods: {
            nav_api: function () {
                window.open('http://127.0.0.1:8000/swagger/', '_blank').location;
            }
        },
        mounted() {
            this.info_class='baimoc-info'
        }
    }
</script>

<style scoped lang="less">
    .navbar-default .navbar-nav > li > a:hover, .navbar-default .navbar-nav > li > a:focus {
        /*color: rgb(84, 109, 229);*/
        background-image: linear-gradient(
                45deg
                ,#9929ea,#5808fb);
        -webkit-background-clip: text;
        color: transparent !important;
        /*background-color: transparent;*/
    }
.el-menu-baimo {
    // box-shadow: ;
    color:red;
}
.baimoc-info {
    color: rgb(255, 208, 75);
    border-bottom-color: rgb(255, 208, 75);
    background-color: rgb(84, 92, 100);
    width: 150px;
    padding-left: 40px;
}
.el-menu.el-menu--horizontal {
    border-bottom: solid 0px red;
}
.footer-dark {
    border-top: 0px solid #e7e7e7;
}
.top {
    height: 90px;
    padding: 10px;
}
nav {
    -moz-box-shadow:0px 1px 1px #C2C2C2; -webkit-box-shadow:0px 1px 1px #C2C2C2; box-shadow:0px 1px 1px #C2C2C2;
    border-top: 1px solid #DEDEDE;
}
.el-menu-item {
    height: 50px
}
.el-menu--horizontal>.el-menu-item{
    float:left;
    height:50px;
    line-height:50px;
    margin:0;
    border-bottom:2px solid transparent;
    color:#909399
}
.el-menu--horizontal>.el-submenu .el-submenu__title{
    height:30px;
    line-height:30px;
    border-bottom:2px solid transparent;
    color:#909399
}
</style>
